import { Injectable } from '@angular/core';
import { CriticalityModel, ODataCriticalityResponseModel } from '../../models/complex/criticality.model';
import { ENDPOINTS } from '../../enums/endpoints.enum';
import { Observable } from 'rxjs';
import { OnlineOnlyService } from '../online-only/online-only.service';

@Injectable({
    providedIn: 'root',
})
export class CriticalityService {
    public constructor(private readonly onlineOnlyService: OnlineOnlyService) {}

    public submitCriticality(
        criticalityModel: CriticalityModel,
    ): Observable<ODataCriticalityResponseModel | ODataCriticalityResponseModel[]> {
        return this.onlineOnlyService.post<ODataCriticalityResponseModel>(
            ENDPOINTS.NotificationCriticalityChange,
            criticalityModel.getOutModel(),
        );
    }
}
